import React from 'react';
import { ReactSVG } from 'react-svg';
import Svg from 'assets/images/payment/amex.svg';

type Props = {
  className?: string;
};

export const AMEX = ({ className }: Props) => {
  return (
    <ReactSVG
      src={Svg}
      className={className}
    />
  );
};
